module.exports = angular.module('msi.payments.form.expiration-date.not-expired-validator', []).name;

const inject = [];
function directive() {
  return {
    restrict: 'A',
    require: ['ngModel', '?^^form'],
    link: ($scope, $elem, $attrs, [ngModel, form]) => {
      ngModel.$validators.expired = function(modelValue, viewValue) {
        const ccExpDate = modelValue || viewValue;
        const validity = !ccExpDate || !ccExpDate.isExpired; // no value is ok.

        if (form) {
          if (form.ccMonth) {
            form.ccMonth.$setValidity('expired', validity);
          }
          if (form.ccYear) {
            form.ccYear.$setValidity('expired', validity);
          }
        }

        return validity;
      };
    }
  };
}

directive.$inject = inject;

angular.module(module.exports)
  .directive('ogNotExpired', directive);
